module.exports = __webpack_public_path__ + "static/media/template1.56873291.png";